module.exports = {"svg":{"$":{"t":"1622451711411","class":"icon","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"2185","width":"64","height":"64","xmlns:xlink":"http://www.w3.org/1999/xlink"},"defs":[{"style":[{"$":{"type":"text/css"}}]}],"path":[{"$":{"d":"M0 767.909l512.029-511.913L1024 767.909 0 767.909z","p-id":"2186","fill":"#EEEEEE"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/assets/svg/k-menu/triangle.svg
// module id = +U75
// module chunks = 1